export default __webpack_public_path__ + "static/media/Picture4.03aa79e4.png";